import { Capacitor } from '@capacitor/core';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';

const REMEMBER_KEY = 'els.login.remembered';

export interface RememberedLogin {
  email: string;
  password: string;
}

const asString = (value: unknown): string => (typeof value === 'string' ? value : '');

const parseNative = (raw: string | null | undefined): RememberedLogin | null => {
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as { email?: unknown; password?: unknown };
    if (!asString(parsed.email)) {
      return null;
    }
    return { email: asString(parsed.email), password: asString(parsed.password) };
  } catch {
    return null;
  }
};

const secureStorageAvailable = (): boolean =>
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('SecureStorage');

export const getRememberedLogin = async (): Promise<RememberedLogin | null> => {
  if (secureStorageAvailable()) {
    const raw = await SecureStorage.get(REMEMBER_KEY).catch(() => null);
    return parseNative(typeof raw === 'string' ? raw : null);
  }
  const parsed = parseNative(window.localStorage.getItem(REMEMBER_KEY));
  return parsed ? { email: parsed.email, password: '' } : null;
};

export const rememberLogin = async (email: string, password: string): Promise<void> => {
  if (secureStorageAvailable()) {
    await SecureStorage.set(REMEMBER_KEY, JSON.stringify({ email, password }));
    return;
  }
  window.localStorage.setItem(REMEMBER_KEY, JSON.stringify({ email }));
};
